export default __webpack_public_path__ + "static/media/ntorq-125.6a13ffe0.svg";